import { FOLDER_COLORS } from '../../useFlowList';

export default function ColorPalette({ value, onChange }) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      {FOLDER_COLORS.map(c => (
        <button
          key={c}
          type="button"
          onClick={() => onChange(c)}
          title={c}
          style={{
            width: 22,
            height: 22,
            borderRadius: '50%',
            background: c,
            border: value === c ? '2px solid #fff' : '2px solid transparent',
            cursor: 'pointer',
          }}
        />
      ))}
    </div>
  );
}
